export type securityPermissionsKeysType = {
  page: string;
  pagePublicUsers: string;
  pageAdminUsers: string;
  pageRolsManagement: string;
};
export const permissionsKeys = {
  page: 'param.security',
  pagePublicUsers: 'param.security.account-users.user.find',
  pageAdminUsers: 'param.security.users-admin.user.find',
  pageRolsManagement: 'param.security.role.find',
  // pageSystemAudit: 'param.security.system-audit.find',
  pageSystemAudit: 'param.security.role.find', //mientras tanto, mientras crean el permiso de auditoria
};
